namespace RecordShield.Workspace {
    export interface ActivationLog2Row {
        Id?: number;
        SerialKey?: string;
        Name?: string;
        Email?: string;
        Mobile?: string;
        SysInfo?: string;
        Channel?: number;
        Status?: number;
        Log?: string;
        ActivationId?: number;
        ProductSerialId?: number;
        AllowedDevices?: Models.Enums.AllowedDevices;
        Views?: number;
        WatchTime?: number;
        ValidityInDays?: number;
        UpdateFrequencyInDays?: number;
        AllowSecondScreen?: boolean;
        ProductId?: number;
        Code?: number;
        SerialKeyItems?: number[];
        ProductName?: string;
        Description?: string;
        AuthorName?: string;
        AuthorDescription?: string;
        SupportInfo?: string;
        DeviceType?: string;
        MachineCode?: string;
        DeviceId?: string;
        ValidFrom?: string;
        ValidTo?: string;
        IsFranchisee?: boolean;
        UserId?: number;
        TenantId?: number;
        UserDisplayName?: string;
        AccessStatus?: Modules.Workspace.SerialKeys.AccessStatus;
        KeyStatus?: Modules.Workspace.SerialKeys.KeyStatus;
        KeyAllowedDevices?: Models.Enums.AllowedDevices;
        TotalAllowedDuration?: number;
    }

    export namespace ActivationLog2Row {
        export const idProperty = 'Id';
        export const nameProperty = 'SerialKey';
        export const localTextPrefix = 'Workspace.ActivationLog2';

        export namespace Fields {
            export declare const Id: string;
            export declare const SerialKey: string;
            export declare const Name: string;
            export declare const Email: string;
            export declare const Mobile: string;
            export declare const SysInfo: string;
            export declare const Channel: string;
            export declare const Status: string;
            export declare const Log: string;
            export declare const ActivationId: string;
            export declare const ProductSerialId: string;
            export declare const AllowedDevices: string;
            export declare const Views: string;
            export declare const WatchTime: string;
            export declare const ValidityInDays: string;
            export declare const UpdateFrequencyInDays: string;
            export declare const AllowSecondScreen: string;
            export declare const ProductId: string;
            export declare const Code: string;
            export declare const SerialKeyItems: string;
            export declare const ProductName: string;
            export declare const Description: string;
            export declare const AuthorName: string;
            export declare const AuthorDescription: string;
            export declare const SupportInfo: string;
            export declare const DeviceType: string;
            export declare const MachineCode: string;
            export declare const DeviceId: string;
            export declare const ValidFrom: string;
            export declare const ValidTo: string;
            export declare const IsFranchisee: string;
            export declare const UserId: string;
            export declare const TenantId: string;
            export declare const UserDisplayName: string;
            export declare const AccessStatus: string;
            export declare const KeyStatus: string;
            export declare const KeyAllowedDevices: string;
            export declare const TotalAllowedDuration: string;
        }

        ['Id', 'SerialKey', 'Name', 'Email', 'Mobile', 'SysInfo', 'Channel', 'Status', 'Log', 'ActivationId', 'ProductSerialId', 'AllowedDevices', 'Views', 'WatchTime', 'ValidityInDays', 'UpdateFrequencyInDays', 'AllowSecondScreen', 'ProductId', 'Code', 'SerialKeyItems', 'ProductName', 'Description', 'AuthorName', 'AuthorDescription', 'SupportInfo', 'DeviceType', 'MachineCode', 'DeviceId', 'ValidFrom', 'ValidTo', 'IsFranchisee', 'UserId', 'TenantId', 'UserDisplayName', 'AccessStatus', 'KeyStatus', 'KeyAllowedDevices', 'TotalAllowedDuration'].forEach(x => (<any>Fields)[x] = x);
    }
}
